/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {z} from '@hono/zod-openapi';

const advertisingTaxonomyDomainSchema = z
  .enum(['vehicle', 'equipment', 'generic'])
  .openapi('AdvertisingTaxonomyDomain');

const advertisingTaxonomySnapshotSchema = z
  .object({
    id: z.string().min(1),
    contentHash: z.string(),
    createdAt: z.string().datetime(),
    recordCount: z.number().int().nonnegative(),
    isLatest: z.boolean(),
    isActive: z.boolean(),
  })
  .openapi('AdvertisingTaxonomySnapshot');

export const advertisingTaxonomyStatusResponseSchema = z
  .object({
    domain: advertisingTaxonomyDomainSchema,
    latest: advertisingTaxonomySnapshotSchema.nullable(),
    active: advertisingTaxonomySnapshotSchema.nullable(),
    activeSnapshotAvailable: z.boolean(),
  })
  .openapi('AdvertisingTaxonomyStatusResponse');

export const advertisingTaxonomyStatusQuerySchema = z
  .object({domain: advertisingTaxonomyDomainSchema})
  .openapi('AdvertisingTaxonomyStatusQuery');

export const advertisingTaxonomySearchQuerySchema = z
  .object({
    domain: advertisingTaxonomyDomainSchema,
    snapshotKind: z.enum(['latest', 'active']).default('latest'),
    snapshotId: z.string().min(1).optional(),
    taxonomyType: z.string().trim().min(1).max(100).optional(),
    query: z.string().trim().max(100).default(''),
    parentExternalId: z.string().trim().min(1).max(100).optional(),
    limit: z.coerce.number().int().min(1).max(20).default(20),
    offset: z.coerce.number().int().nonnegative().default(0),
  })
  .openapi('AdvertisingTaxonomySearchQuery');

const advertisingTaxonomySearchItemSchema = z
  .object({
    taxonomyType: z.string(),
    externalId: z.string(),
    label: z.string().nullable(),
    normalizedKey: z.string(),
    parent: z.object({externalId: z.string(), label: z.string().nullable()}).nullable(),
  })
  .openapi('AdvertisingTaxonomySearchItem');

export const advertisingTaxonomySearchResponseSchema = z
  .object({
    snapshot: advertisingTaxonomySnapshotSchema,
    items: z.array(advertisingTaxonomySearchItemSchema),
    pagination: z.object({
      limit: z.number().int().positive(),
      offset: z.number().int().nonnegative(),
      total: z.number().int().nonnegative(),
    }),
  })
  .openapi('AdvertisingTaxonomySearchResponse');
